/**
 * Modal de confirmación estilizado.
 * Props:
 *   abierto:    boolean
 *   titulo:     string
 *   mensaje:    string  (soporta \n)
 *   peligro:    boolean (botón confirmar rojo)
 *   textOk:     string  (defecto "Confirmar")
 *   onConfirm:  () => void
 *   onCancel:   () => void
 */
export default function ConfirmDialog({ abierto, titulo, mensaje, peligro, textOk = 'Confirmar', onConfirm, onCancel }) {
  if (!abierto) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/40">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm animate-fade-in">
        <div className="p-6">
          {titulo && (
            <div className="flex items-center gap-3 mb-3">
              {peligro && (
                <div className="w-9 h-9 rounded-full bg-red-100 flex items-center justify-center shrink-0">
                  <svg className="w-5 h-5 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                          d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/>
                  </svg>
                </div>
              )}
              <h3 className="font-bold text-gray-900 text-base">{titulo}</h3>
            </div>
          )}
          {mensaje && (
            <p className="text-sm text-gray-600 whitespace-pre-line leading-relaxed">{mensaje}</p>
          )}
        </div>
        <div className="px-6 pb-6 flex gap-3">
          <button onClick={onCancel}
            className="flex-1 border border-gray-300 text-gray-700 font-semibold text-sm
                       py-2.5 rounded-xl hover:bg-gray-50 transition">
            Cancelar
          </button>
          <button onClick={onConfirm}
            className={`flex-1 text-white font-semibold text-sm py-2.5 rounded-xl transition
              ${peligro
                ? 'bg-red-600 hover:bg-red-700'
                : 'bg-primary-600 hover:bg-primary-700'}`}>
            {textOk}
          </button>
        </div>
      </div>
    </div>
  );
}
